module.exports = __webpack_public_path__ + "spa_static_mobile/img/sharea.b7162987.jpg";